import { render, staticRenderFns } from "./DocsListSupplierDocs.vue?vue&type=template&id=0bdfb2ec&"
import script from "./DocsListSupplierDocs.vue?vue&type=script&lang=js&"
export * from "./DocsListSupplierDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports